import { mount } from 'svelte';
import SpaceContactFooter from '../src/svelte/space/SpaceContactFooter.svelte';
import type { SpaceContactFooterProps } from '../src/svelte/types/space/space_contact_footer';
import { syncContactFooterVisibility } from '../src/js/space-contact-footer-visibility';

document.addEventListener('DOMContentLoaded', () => {
  const element = document.getElementById('space-contact-footer');
  if (element?.dataset.props) {
    const props = JSON.parse(element.dataset.props) as SpaceContactFooterProps;
    mount(SpaceContactFooter, { target: element, props });

    if (element.dataset.visibilityHost) {
      syncContactFooterVisibility(element);
    }
  }
});
